/* 此插件用于下拉框改变传参给
页面中的内嵌网页：取值value 参数名semester
表单数据源，图表数据源组件：取值value 参数名 sw ：添加插件 getSelectValuePlugin 来识别
getSelectValuePlugin：传递参数uid/userId 和  学期 semester
getUidValuePlugin：传递参数uid
 */
import { getDocumentCookie, getQueryParam, replaceUrlParam } from "@/utils"
export default {
  data() {
    return {
      getValueComponentArr: [],  //所有获取下拉框参数的组件集合
      getUidComponentArr: [],  //所有获取页面uid参数的组件集合
    }
  },
  watch: {
    value(n, o){
      if(n !== o){
        this.responseComponentUpdate()
      }
    }
  },
  methods: {
    transferValuePlugin() {
    //  查找页面中所有内嵌网页组件
      this.getValueComponentArr = this.$store.state[this.request_prefix].page.children[0].children.filter((item)=>{
        if(item.shape === "cxIframe"){
          return item
        }else if(item.options && item.options?.pluginName && item.options?.pluginName?.includes("getSelectValuePlugin")){
          return item
        }else if(item.options && item.options?.chartOption && item.options?.chartOption?.pluginName && item.options?.chartOption?.pluginName?.includes("getSelectValuePlugin")){
          return item
        }
      })
      this.getUidComponentArr = this.$store.state[this.request_prefix].page.children[0].children.filter((item)=>{
        if(item.options && item.options?.pluginName && item.options?.pluginName?.includes("getUidValuePlugin")){
          return item
        }else if(item.options && item.options?.chartOption && item.options?.chartOption?.pluginName && item.options?.chartOption?.pluginName?.includes("getUidValuePlugin")){
          return item
        }
      })
      setTimeout(()=>{
        this.responseComponentUpdate()
        this.responseUidComponentUpdate(this.getUidComponentArr)
      }, 500)
    },
    responseComponentUpdate() {
      if(this.getValueComponentArr.length > 0){
        let idsArr = []
        //循环响应组件
        for(let i=0; i<this.getValueComponentArr.length;i++){
          let item = this.getValueComponentArr[i]
          let ids1 = {
            "container_id": this.myid.container_id,
            "rect_id": item.rect_id
          }
          idsArr.push(ids1)
          let toContext = this.$event.getContext({ ...ids1 })
          const uid = getQueryParam("uid") || getDocumentCookie("UID") || ""
          if(item.shape === "cxIframe"){
            /* 页面中下拉框传参给内嵌网页：参数取value值作为 学期参数值
            内嵌网页初始化和下拉框切换时还需要传参uid：来源url或者cookie，优先级是url>cookie
             */
            //内嵌网页传值value
            ids1.option_name = "iframeUrl"
            let iframeUrlOld = item.options.iframeUrl
            // 判断是否有uid
            if(iframeUrlOld.indexOf("userId") === -1){
              iframeUrlOld = iframeUrlOld + (iframeUrlOld.indexOf("?") === -1 ? "?userId=": "&userId=") + uid
            }else{
              iframeUrlOld = replaceUrlParam(iframeUrlOld,"userId",uid)
            }
            // 判断是否有semester
            if(iframeUrlOld.indexOf("semester") === -1){
              iframeUrlOld = iframeUrlOld + (iframeUrlOld.indexOf("?") === -1 ? "?semester=": "&semester=") + this.options.linkValue
            } else {
              iframeUrlOld = iframeUrlOld.split("semester=")[0] + "semester=" + this.options.linkValue
            }
            ids1.option_val = iframeUrlOld
          }else{
            ids1.option_name = "eventQuery"
            ids1.option_val = uid + "###" + this.options.value
          }
          this.changeOption(ids1, toContext)
          if(item.shape === "emptyLayoutComponent"){
            //  自由布局更新数据
            this.$eventBus.$emit(`update-layout-data-eventBus-${ids1.container_id}-${ids1.rect_id}`, {
              updateLayout: true
            })
          }
          else if(item.shape === "swiperComponent"){
            this.$eventBus.$emit(`update-swiper-data-eventBus-${ids1.container_id}-${ids1.rect_id}`, {
              updateLayout: true
            })
          }
          else if(item.shape !== "cxIframe"){
            //图表组件响应数据
            toContext.updateData()
          }
        }
      }
    },
    responseUidComponentUpdate(uidArr) {
      if(uidArr.length > 0){
        let idsArr = []
        //循环响应组件
        for(let i=0; i<uidArr.length;i++){
          let item = uidArr[i]
          let ids1 = {
            "container_id": this.myid.container_id,
            "rect_id": item.rect_id
          }
          idsArr.push(ids1)
          let toContext = this.$event.getContext({ ...ids1 })
          const uid = getQueryParam("uid") || getDocumentCookie("UID") || ""
          ids1.option_name = "eventQuery"
          ids1.option_val = uid
          this.changeOption(ids1, toContext)
          if(item.shape === "emptyLayoutComponent"){
            //  自由布局更新数据
            this.$eventBus.$emit(`update-layout-data-eventBus-${ids1.container_id}-${ids1.rect_id}`, {
              updateLayout: true
            })
          }
          else if(item.shape === "swiperComponent"){
            this.$eventBus.$emit(`update-swiper-data-eventBus-${ids1.container_id}-${ids1.rect_id}`, {
              updateLayout: true
            })
          }
          else if(item.shape === "cxTable"){
            this.$eventBus.$emit(`update-table-data-eventBus-${ids1.container_id}-${ids1.rect_id}`, {
              dateVal: '',
              keepQueryValue: true
            })
          }
          else {
            //图表组件响应数据
            toContext.updateData()
          }
        }
      }
    },
    /* 拷贝event.js的方法修改组件属性 */
    changeOption(param, fromContext) {
      if (param.uid != null) {
        fromContext.$store.dispatch(fromContext.request_prefix + "/changeLayoutOption", param)
      } else if (typeof param.elementInSwiperId !== "undefined" && param.elementInSwiperId !== null) {
        fromContext.$store.dispatch(fromContext.request_prefix + "/changeSwiperOptions", param)
      } else {
        fromContext.$store.dispatch(fromContext.request_prefix + "/changeOptions", param)
      }
    }
  }
}
